import DealRecommended from './DealRecommended'

export * from './DealRecommended'

export default DealRecommended
